import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://kofi.dev';

const apiClient = axios.create({
    baseURL: 'http://localhost:8888',
    headers: {
        'Content-Type': 'application/json'
    }
});

const _get = (url) => {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

const _delete = (url, config = {}) => {
    return apiClient.delete(url, config);
};

const _put = (url, data = {}, config = {}) => {
    return apiClient.put(url, data, config);
};

const _post = (url, data) => {
    if(!data) {
        return Promise.reject("data cannot be null");
    }
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
};

export { _get, _delete, _put, _post };
